export enum UserType {
  guest = "guest",
  wallet = "wallet",
  unknown = "unknown",
}
